import type { ReadonlyDeep } from 'type-fest';
import type { DataItem as DetailedJobAirRoadJobsTableDataItem } from '@/components/tables/DetailedJobAirRoadJobsTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { arJobStatuses } from '@/utils/PortalConstants';
import { getStrCell } from '@/utils/file';
import * as airRoadJobProductsTableHelpers from '@/helpers/tables/airRoadJobProducts';

function getPod(arJobPod?: openapi.AirroadJobOpenapi['pod']): string {
  if (!arJobPod || Object.keys(arJobPod).length === 0) {
    return 'No';
  } else {
    return 'Yes';
  }
}

export function getTableItem(
  arJob: ReadonlyDeep<openapi.AirroadJobOpenapi>,
): DetailedJobAirRoadJobsTableDataItem {
  const status = arJobStatuses.find(
    (arJobStatus) => arJobStatus.value === arJob.status,
  )?.text;
  return {
    id: arJob.id,
    connote: arJob.connote,
    status: getStrCell(status),
    locationCode: getStrCell(arJob.location_code),
    totalWeight: getStrCell(arJob.total_weight),
    totalVolume: getStrCell(arJob.total_volume),
    items: getStrCell(arJob.items?.length),
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    scans: getStrCell(arJob.scans?.length),
    pod: getPod(arJob.pod),
    fold: {
      // TODO
      // @ts-expect-error
      specialOptions: arJob.special_options,
      // TODO
      // @ts-expect-error
      stops: arJob.stops,
      list1: [
        {
          name: 'Job type:',
          value: arJob.job_type,
        },
        {
          name: 'Status:',
          value: status,
        },
        {
          name: 'Reference 1:',
          value: arJob.reference_1,
        },
        {
          name: 'Reference 2:',
          value: arJob.reference_2,
        },
        {
          name: 'Service type:',
          value: arJob.service_type,
        },
      ],
      list2: [
        {
          name: 'Connote:',
          value: arJob.connote,
        },
        {
          name: 'AR code:',
          value: arJob.location_code,
        },
        {
          name: 'ETA:',
          value: arJob.eta,
        },
        {
          name: 'Instructions:',
          value: arJob.instructions,
        },
      ],
      airRoadJobsProductsTableData: arJob.items?.map((arJobItem) => {
        return airRoadJobProductsTableHelpers.getTableItem(arJobItem);
      }),
      airRoadJobsProductsTableTotalData: {
        volume: getStrCell(
          // TODO
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          arJob.total_volume != null
            ? arJob.total_volume.toString() + ' m³'
            : arJob.total_volume,
        ),
        weight: getStrCell(
          // TODO
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          arJob.total_weight != null
            ? arJob.total_weight.toString() + ' kg'
            : arJob.total_weight,
        ),
      },
    },
  };
}
